export default __webpack_public_path__ + "static/media/certificates.1b319026.pdf";